import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Input, Form, Card, CardHeader, CardBody } from '@heroui/react';
import authService from '../../services/auth.service';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('Invalid reset link');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setIsLoading(true);

    try {
      await authService.resetPassword(token, password);
      navigate('/login', {
        state: { message: 'Password reset successful. Please login with your new password.' },
      });
    } catch (err) {
      setError(err?.message || 'Failed to reset password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 px-4"
      style={{ fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}
    >
      <Card className="max-w-md w-full" style={{ padding: '48px' }}>
        <CardHeader className="flex flex-col gap-3 px-0 pt-0 pb-6">
          <div className="flex justify-center w-full mb-2">
            <img 
              src="/taasa-logo.png" 
              alt="Taasa Logo" 
              className="h-20 w-auto"
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 text-center">Reset Password</h1>
          <p className="text-gray-600 text-center">Enter your new password</p>
        </CardHeader>
        
        <CardBody className="px-0 py-0">
          <Form onSubmit={handleSubmit} className="flex flex-col gap-4">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                {error}
              </div>
            )}

            <Input
              type="password"
              label="New Password"
              labelPlacement="outside"
              placeholder="Enter new password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              isRequired
              size="lg"
            />

            <Input
              type="password"
              label="Confirm Password"
              labelPlacement="outside"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              isRequired
              size="lg"
            />

            <Button
              type="submit"
              color="primary"
              size="lg"
              className="w-full"
              isLoading={isLoading}
              disabled={isLoading}
            >
              Reset Password
            </Button>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default ResetPassword;